import { PrimaryButton, SecondaryButton } from '../components/Button';
import { Card, StatCard } from '../components/Card';
import { Screen } from '../components/Screen';
import { copy } from '../copy';
import { navigationHref, openExternal } from '../lib/links';
import { formatKmWhole, formatMinutes } from '../lib/time';
import { stopCounts } from '../state/route';
import { useAppStore } from '../state/store';

/** I1 — Terugrit. Verschijnt automatisch zodra geen stop meer open is (D116). */
export function ReturnScreen() {
  const route = useAppStore((s) => s.route);
  const openSheet = useAppStore((s) => s.openSheet);

  if (!route) return null;

  const counts = stopCounts(route);
  const destination = {
    lat: route.pickupPoint.lat,
    lng: route.pickupPoint.lng,
    label: route.pickupPoint.name,
    addressLine: route.pickupPoint.addressLine,
    postalCodeCity: route.pickupPoint.postalCodeCity,
  };
  const minutes = formatMinutes(route.route.returnLegDurationSeconds);
  const km = formatKmWhole(route.route.returnLegDistanceMeters);

  return (
    <Screen
      name="return"
      foot={
        <>
          <SecondaryButton onClick={() => openExternal(navigationHref(destination))}>
            {copy.ret.navigate}
          </SecondaryButton>
          <PrimaryButton onClick={() => openSheet('complete')}>{copy.ret.complete}</PrimaryButton>
        </>
      }
    >
      <div className="pad-x" style={{ paddingTop: 20 }}>
        <h1 className="t-serif" style={{ fontSize: 30 }}>
          {copy.ret.title}
        </h1>
        <p className="o-75" style={{ fontSize: 17, marginTop: 8, marginBottom: 0 }}>
          {copy.ret.body}
        </p>
      </div>

      <div className="stack pad-x" style={{ paddingTop: 22 }}>
        <Card>
          <div className="row" style={{ gap: 14, alignItems: 'flex-start' }}>
            <span className="dot-pickup" aria-hidden />
            <div>
              <div style={{ fontSize: 18, fontWeight: 600 }}>
                {copy.day.pickupPoint(route.pickupPoint.name)}
              </div>
              <div style={{ fontSize: 18, marginTop: 2 }}>
                {route.pickupPoint.addressLine}
                <br />
                {route.pickupPoint.postalCodeCity}
              </div>
              {minutes && km ? (
                <div className="t-caption" style={{ color: 'var(--text-65)', marginTop: 6 }}>
                  {copy.ret.leg(minutes, km)}
                </div>
              ) : null}
            </div>
          </div>
        </Card>

        <div className="grid-2">
          <StatCard value={String(counts.delivered)} label={copy.ret.delivered} tone="mint" />
          <StatCard
            value={String(counts.failed)}
            label={copy.ret.failed}
            tone={counts.failed > 0 ? 'terracotta' : 'default'}
          />
        </div>
      </div>
    </Screen>
  );
}
